<template>
    <div style="background-color: blue;width: 100%; height: 40px;position:absolute:">
      <div id="app text-white">
        Last updated:Month: {{ new Date().getMonth() }}
      </div>
      <div>
        <p>Copyright cb @2019</p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HeaderFooter/Footer.vue